// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1_lqo","cls2":"NewsHeader-cls2_Ktq NewsHeader-cls1_lqo","variant-dense":"NewsHeader-variant-dense_XXN"};